import {
  ArrowLeftOnRectangleIcon,
  BuildingOfficeIcon,
  ChartBarSquareIcon,
  ChatBubbleLeftRightIcon,
  CurrencyDollarIcon,
  HomeIcon,
  MegaphoneIcon,
  PhoneIcon,
  QueueListIcon,
  ShieldCheckIcon,
  TagIcon,
  UserGroupIcon,
  UserIcon,
} from "@heroicons/react/24/outline";
import React from "react";
import {
  AgencyPath,
  AutomationPath,
  BackupAgentsPath,
  CampaignPath,
  ClientsPath,
  CommissionsPath,
  ConversationsPath,
  DashboardPath,
  LeadsPath,
  PhonePath,
  PoliciesPath,
  TagsPath,
  UsersPath,
} from "../constants/Routes";
import { NavItemKey } from "../enums/NavItemKey";
import FirebaseService from "../state/firebase/FirebaseService";
// define a NavItem prop
export type NavItem = {
  key: number;
  label: string;
  href?: string;
  action?: Function;
  icon: React.ReactNode;
};
export const communicationNavItems: NavItem[] = [
  {
    label: "Conversations",
    href: ConversationsPath,
    key: NavItemKey.CONVERSATIONS,
    icon: <ChatBubbleLeftRightIcon className="w-6 h-6" />,
  },
  {
    label: "Phone",
    href: PhonePath,
    key: NavItemKey.PHONE,
    icon: <PhoneIcon className="w-6 h-6" />,
  },
];

export const defaultNavItems: NavItem[] = [
  {
    label: "Dashboard",
    href: DashboardPath,
    key: NavItemKey.DASHBOARD,
    icon: <ChartBarSquareIcon className="w-6 h-6" />,
  },
  {
    label: "Leads",
    href: LeadsPath,
    key: NavItemKey.LEADS,
    icon: <UserIcon className="w-6 h-6" />,
  },
  {
    label: "Clients",
    href: ClientsPath,
    key: NavItemKey.CLIENTS,
    icon: <UserGroupIcon className="w-6 h-6" />,
  },
  {
    label: "Policies",
    href: PoliciesPath,
    key: NavItemKey.POLICIES,
    icon: <ShieldCheckIcon className="w-6 h-6" />,
  },
  {
    label: "Campaigns",
    href: CampaignPath,
    key: NavItemKey.CAMPAIGNS,
    icon: <MegaphoneIcon className="w-6 h-6" />
  }
];

export const otherNavItems: NavItem[] = [
  {
    label: "Tags",
    href: TagsPath,
    key: NavItemKey.TAGS,
    icon: <TagIcon className="w-6 h-6" />,
  },
  {
    label: "Automations",
    href: AutomationPath,
    key: NavItemKey.LEAD_AUTOMATIONS,
    icon: <QueueListIcon className="w-6 h-6" />,
  },
];

export const agentNavItems: NavItem[] = [
  {
    label: "Commissions",
    href: CommissionsPath,
    key: NavItemKey.COMMISSIONS,
    icon: <CurrencyDollarIcon className="w-6 h-6" />,
  },
  {
    label: "Backup Agents",
    href: BackupAgentsPath,
    key: NavItemKey.BACKUP_AGENTS,
    icon: <BuildingOfficeIcon className="w-6 h-6" />,
  }
];

export const adminNavItems: NavItem[] = [
  {
    label: "Commissions",
    href: CommissionsPath,
    key: NavItemKey.COMMISSIONS,
    icon: <CurrencyDollarIcon className="w-6 h-6" />,
  },
  {
    label: "Users",
    href: UsersPath,
    key: NavItemKey.USERS,
    icon: <BuildingOfficeIcon className="w-6 h-6" />,
  },
  {
    label: "Agency",
    href: AgencyPath,
    key: NavItemKey.AGENCY,
    icon: <HomeIcon className="w-6 h-6" />,
  }
 /*,
  {
    label: "Metadata",
    href: MetadataPath,
    key: NavItemKey.METADATA,
    icon: <CircleStackIcon className="w-6 h-6" />,
  }*/,
];

export const defaultNavOptions: NavItem[] = [
  {
    label: "Sign Out",
    key: NavItemKey.SIGN_OUT,
    icon: <ArrowLeftOnRectangleIcon className="w-6 h-6" />,
    action: () => FirebaseService.logout(),
  },
];
